
import React from 'react'
import { Tabs, Menu, Col, Input, Radio, Avatar, Empty, Row, Tooltip, Checkbox, Card, Tag, message } from 'antd';
import { api, app, config } from 'xadmin'
import { Loading } from 'xadmin-ui'
import NoData from './NoData'

import NodeTree from './NodeTree'
import _ from 'lodash'
import './ModelPointTable.css'
const TabPane = Tabs.TabPane
const RadioGroup = Radio.Group
const CheckboxGroup = Checkbox.Group;

const AvatarIcon = (props) => {
  if (props.icon) {
    return <Avatar size={20} shape="square" src={config('mediaUrl') + props.icon} style={{ margin: '0 10px 3px 0' }} />
  } else {
    return <Avatar size={20} shape="square" style={{ margin: '0 10px 3px 0' }}>M</Avatar>
  }
}

const convert_values = (data) => {
  if (!data || JSON.stringify(data) == '{}' || !_.isArray(data)) return {}
  let object = {}
  let arr = []
  data.forEach(item => {
    const model_id = item && item.model && item.model.id
    if (Object.keys(object).indexOf(model_id) > -1) {
      object[model_id].push(item)
    } else {
      object[model_id] = [item]
    }
  })
  return object

}

class ModelPointTable extends React.Component {
  constructor(props) {
    super(props);
    this.data = []
    const { value, input } = props
    const selectedKey = value ? (value.model && value.model.id ? [value.model.id] : [])
      : (input && input.value && input.value.model && input.value.model.id && [input.value.model.id]) || []
    const selectValue = value ? value.id : (input && input.value && input.value.id)
    this.checkedkeys = []
    this.state = {
      models: null,
      activeKey: 'Tabs',
      model: {},
      tagData: null,
      value: null,
      loading: false,
      loadings: false,
      selectedKey: selectedKey,
      selectValue: selectValue,
      checkedList: convert_values(value ? value : (input && input.value && input.value)),
      checkedData: value ? value : (input && input.value && input.value)
    }
  }

  RelationsFun = (modelId, items) => {
    let arrmodel = []
    if (modelId && items) {
      if (this.props.child) {
        arrmodel = items[0] && items[0]['relations'] && items[0]['relations']['child'] || []
      } else {
        const relations = Object.values(items[0] && items[0]['relations']) || []
        relations.map(k => {
          if (k) k.map(item => {
            if (item) arrmodel.push(item)
          })
        })
      }
      return arrmodel
    }
  }
  componentDidMount() {
    const { modelId, value } = this.props
    const { selectedKey } = this.state
    const where = modelId && { where: { 'id': modelId } }
    this.setState({ loading: true })
    const schema = app.load_dict('models')['Model']
    api({ ...schema })
      .query({ fields: ['icon', 'relations'] }, where)
      .then(({ items }) => {
        if (items && !_.isEmpty(items)) {
          this.setState({ models: modelId ? this.RelationsFun(modelId, items) : items, loading: false })
        }
        if (selectedKey && selectedKey.length > 0) {
          this.onClick({ key: selectedKey[0], tabskey: value && value.type, item: items[0] })
        }
      })
  }

  onClick = ({ item, key, tabskey }) => {
    if (!item) return false
    const prop = {
      id: key || (item && item.props && item.props.eventKey) || (item.id),
      name: (item && item.props && item.props.name) || (item.name)
    }
    const { tagData } = this.state
    this.setState({ loadings: true })
    api({ name: 'core/model/tag' }).get(key || '').then((json) => {
      if (json) {
        let newJson;
        newJson = json?.tags?.length ? json.tags.map((tag) => ({
          ...tag,
          model: prop,
          ref_id: tag.id + '_' + prop.id
        })) : []
        if (this.props.noComputed) {
          newJson = newJson?.length ? newJson.filter(item => !item?.type) : []
          json = { ...json, tags: newJson }
        }
        this.setState({ tagData: json, loadings: false })
        if (newJson) this.data = tagData && [...tagData.tags, ...newJson] || newJson
        if (json.types) this.setState({ activeKey: json.types[0] })
      }
    })
    let model = this.state.models.filter(opt => opt.id == key)[0]
    this.setState({ activeKey: tabskey || '', model, targetValue: null })
  }

  convert_data = (checkedList) => {
    return checkedList && Object.values(checkedList).reduce((prev, curr) => {
      return prev.concat(curr)
    }, []) || []
  }

  onChange = (value) => {
    const { onChange, type, input } = this.props
    const { model, tagData, checkedList } = this.state
    let data = {}
    if (_.isArray(value) && type == 'checkbox') {
      checkedList[model.id] = _.intersectionWith(this.data, value, (a, c) => {
        let hasA
        if (_.isArray(c)) {
          hasA = c?.indexOf(a.id) >= 0
        } else if (_.isString(c)) {
          hasA = c == a.id
        } else if (_.isPlainObject(c)) {
          hasA = c.id == a.id
        }
        return hasA && a?.model?.id == model?.id
      })
      const newdata = this.convert_data(checkedList)
      this.setState({ checkedList, checkedData: newdata })
      data = newdata
    } else {
      const target = value.target
      const curTag = _.find(tagData?.tags, (o) => o.id == target?.value)

      data = {
        ...curTag || {},
        id: target.value || '',
        name: target.label || '',
        model: this.state.model,
        type: this.state.activeKey
      }
      this.setState({ selectValue: target.value || '' })
    }
    if ((onChange && _.isFunction(onChange)) || (input && input.onChange)) {
      input ? input.onChange(data) : onChange(data)
    } else {
      message.error('onChange事件出错了！')
    }
  }

  onTabChange = activeKey => this.setState({ activeKey })

  TabPaneRadio = (tab, data, type) => {
    const { model, selectValue, checkedList } = this.state
    const Title = (opt) => {
      return (
        < div >
          <p style={{ marginBottom: -5 }}>{opt && opt.name}({opt && opt.id})</p>
          {opt?.remark && <span>备注：{opt?.remark}</span>}
        </div >
      )
    }
    if (!type || type == 'radio') {
      return (
        <TabPane tab={tab} key={tab}>
          <RadioGroup onChange={this.onChange} value={selectValue || ''}>
            {
              data.tags.map(opt => (
                <span style={{ display: 'inline-block' }}>
                  <Radio
                    style={{ width: 100, height: 30, marginRight: 60, marginLeft: 35 }}
                    label={opt && opt.name}
                    value={opt?.id}
                  >
                    <Tooltip title={Title(opt)}>
                      <span style={{
                        maxWidth: '150px', display: 'inline-block', height: '25px', lineHeight: '25px',
                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: '-8px'
                      }}>
                        {opt && opt.name}
                        <span style={{ color: '#ccc', fontSize: '13px' }}> ( {opt && opt.id || null} )</span>
                      </span>
                    </Tooltip>
                  </Radio>
                </span>
              ))
            }
          </RadioGroup>
        </TabPane>
      )
    } else if (type == 'checkbox') {
      return <TabPane tab={tab} key={tab}>
        <CheckboxGroup onChange={this.onChange} value={checkedList[model.id] && checkedList[model.id].map(i => i.id)} >
          {
            data.tags.map(opt => (
              <span style={{ display: 'inline-block', width: 200, height: 30, marginRight: 20, marginLeft: 25 }}>
                <Checkbox value={opt && opt.id} >
                  <Tooltip title={Title(opt)}>
                    <span style={{
                      maxWidth: '150px', display: 'inline-block', height: '25px', lineHeight: '25px',
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: '-8px'
                    }}>
                      {opt && opt.name}
                      <span style={{ color: '#ccc', fontSize: '13px' }}> ( {opt && opt.id || null} )</span>
                    </span>
                  </Tooltip>
                </Checkbox>
              </span>
            ))
          }
        </CheckboxGroup>
      </TabPane>
    }
  }

  RenderTabPane = (data = {}) => {
    if (data.tags && data.types) {
      return data.types.map(tab => (this.TabPaneRadio(tab, data, this.props.type)))
    } else if (data.tags && !data.types) {
      return this.TabPaneRadio(this.state.model?.name || 'Tab', data, this.props.type)
    }
    return <TabPane tab="暂无数据" key=""> 暂无数据 </TabPane >
  }

  InputChange = (event) => {
    this.setState({ targetValue: event.target.value })
    const { tagData } = this.state
    let filter_tags = this.data.filter(opt => {
      if (opt.name) return (opt.name + opt.id).indexOf(event.target.value) != -1
    })
    tagData['tags'] = filter_tags
    this.setState({ tagData })
  }

  onChangeClear = (v) => {
    const { checkedList } = this.state
    const { input: { onChange }, onChange: onChanges } = this.props
    const newdata = this.convert_data(checkedList).filter(item => item.ref_id != v.ref_id)
    this.setState({ checkedList: convert_values(newdata), checkedData: newdata }, () => {
      onChange ? onChange(newdata) : onChanges ? onChanges(newdata) : null
    })
  }

  render() {
    const { models, tagData, activeKey, targetValue, selectedKey, loading, loadings, checkedData, checkedList } = this.state
    return [<>
      {
        (this.props.type != 'radio' && checkedData && checkedData.length > 0) ? (
          <Card bodyStyle={{ width: '100%', borderRadius: '5px', padding: 5 }}>
            {checkedData.map(item => (
              <span key={item.name}>
                <Tooltip title={'所属模型 ' + (item.model && item.model.name || '')}>
                  <Tag closable onClose={() => this.onChangeClear(item)}>{
                    this.props.fullLable ? item?.model?.name + '-' + item.name : item.name
                  }</Tag>
                </Tooltip>
              </span>
            ))}
          </Card>
        ) : null
      }</>,
    <div className="ModelPointTable">
      <div className="ModelPointTable-left">
        <div className="ModelPointTable-left-title">请选择模型</div>
        <div className="ModelPointTable-left-list">
          <Menu theme="dark" mode="inline" onSelect={this.onClick} defaultSelectedKeys={selectedKey}>
            {
              loading ? <Loading /> : models && models.length > 0 ? models.map(item => (
                <Menu.Item name={item.name} key={item.id}>
                  <AvatarIcon icon={item.icon} />
                  <span>{item.name}</span>
                </Menu.Item>
              )) : null
            }
          </Menu>
        </div>
      </div>
      <div style={{ width: '100%' }} >
        <div className="ModelPointTable-right">
          <Input placeholder="变量搜索..." style={{ border: 'none' }} value={targetValue} onChange={this.InputChange} />
        </div>
        <div style={{ height: '330px', overflow: 'auto' }}>
          {
            loadings ? <Loading /> : tagData ?
              <Tabs defaultActiveKey={activeKey} onChange={this.onTabChange}>
                {this.RenderTabPane(tagData)}
              </Tabs>
              : <NoData />
          }
        </div>

      </div>
    </div>
    ]
  }
}
export default ModelPointTable
